import { CheckboxFilterComponent } from './checkbox-filter/checkbox-filter.component';
import { InputFilterComponent } from './input-filter/input-filter.component';
import { SelectFilterComponent } from './select-filter/select-filter.component';

const Components = [
	CheckboxFilterComponent,
	InputFilterComponent,
	SelectFilterComponent,
];

export {
	Components,

	CheckboxFilterComponent,
	InputFilterComponent,
	SelectFilterComponent,
};
